import React from "react";
import FormPage from "../../components/forms/FormPage";
import { IntellexusDateField } from "../../components/forms/common/intellexusDate/IntellexusDateField";
import { useParams } from "react-router-dom";
import useTeamController from "../../controllers/teamController";
import { SystemLanguages } from "../../shared/enums/shared-enums";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import TeamMemberSection from "./sections/TeamMembersSection";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import renderVersionSelection from "../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import renderPlaceSelection from "../../components/entitiesReferences/SelectionModals/PlaceSelectionModal";
import FormTextField from "../../components/forms/fields/basic/TextField";
import { Team } from "../../types/team";
import useTeamLogic from "../../hooks/logic/teamLogic";

interface AddEditTeamPagePageProps {
  systemLanguageType: Team["system_language_type"];
}

const AddEditTeamPage: React.FC<AddEditTeamPagePageProps> = ({
  systemLanguageType,
}) => {
  const { _id = null } = useParams<{
    _id?: string;
  }>();
  const {
    showField,
    revisionEnum,
    sourceLanguageEnum,
    placeIdentificationStatusEnum,
  } = useTeamLogic(systemLanguageType);
  const controller = useTeamController(_id || null, systemLanguageType);
  const formController = { ...controller, title: controller.editTitle };

  return (
    <FormPage<Team>
      controller={formController}
      sections={(team) => [<TeamMemberSection team={team} />]}
    >
      <FormTextField name="name" label="Name" placeholder="Name" />
      <FormSelectField
        name="source_language"
        label="Source Language"
        placeholder="Select Source Language"
        useEnum={sourceLanguageEnum}
      />
      <IntellexusDateField
        name="team_contribution_date"
        label="Team Contribution Date"
      />
      {showField("version") && (
        <FormEntitySelectionField
          name="version"
          label="Version"
          placeholder="Select a version"
          entityCollection={SystemEntityCollections.VERSION}
          renderEntitySelection={renderVersionSelection(
            SystemLanguages.tibetan
          )}
        />
      )}
      {showField("revision") && (
        <FormSelectField
          name="revision"
          label="Revision"
          placeholder="Select Revision"
          useEnum={revisionEnum}
        />
      )}
      {showField("title") && (
        <FormTextField
          name="title"
          label="Title"
          placeholder="Enter the title"
        />
      )}
      {showField("taisho_catalog_no") && (
        <FormTextField
          name="taisho_catalog_no"
          label="Taisho Catalog Number"
          placeholder="Enter the Taisho catalog number"
        />
      )}
      <FormEntitySelectionField
        name="place"
        label="Place"
        placeholder="Select a place"
        entityCollection={SystemEntityCollections.PLACE}
        renderEntitySelection={renderPlaceSelection}
      />
      <FormSelectField
        name="place_identification_status"
        label="Place Identification Status"
        placeholder="Select Place Identification Status"
        useEnum={placeIdentificationStatusEnum}
      />
    </FormPage>
  );
};

export default AddEditTeamPage;
